import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Tooltip, OverlayTrigger, } from 'react-bootstrap';
import { Link } from "react-router-dom";
import $ from 'jquery';
import axios from 'axios';

const TransferLog = ({ show, onClose, data }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);

    const fetchdata = () => {
        axios.get(`${baseURL}/managelead/transfer_log/${data.sno}`)
            .then(response => {
                setData(response.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    }

    useEffect(() => {
        if(data){
            fetchdata();
        }
    }, [data]);


    const tableRef = useRef(null);
    useEffect(() => {
        if(hasFetched){
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        paging: false,
                        scrollY: "230px", // Set the scroll height here
                        scrollCollapse: true,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":

                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // format date display
    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (

        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Lead Transfer Log Details</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Lead</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-black fs-6 font-w500'>{data.mobile_no}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Lead Source</label>
                            <label className='text-black fs-6 font-w500'>{data.lead_sources_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Registered Date</label>
                            <label className='text-black fs-6 font-w500'>{formatDate(data.created_at)}</label>
                        </div>

                        <div className='col-lg-12 mb-2'>
                            <div className="table-container"  >
                                <table ref={tableRef} className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                            <th className='min-w-80px text-start'>Staff</th>
                                            <th className='min-w-50px text-center'>Transferred From</th>
                                            <th className='min-w-100px'>End Date</th>
                                            <th className='min-w-80px'>Duration</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                        {datas.map((data, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.curent_staff_name}</label>
                                                </td>
                                                <td className='text-center'>
                                                    <label className='text-black font-w400 fs-7'>{data.old_staff_name ? data.old_staff_name : '-'}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.old_staff_name ? formatDate(data.end_date) : '-'}</label>
                                                </td>
                                                <td>
                                                    <label className='text-black font-w400 fs-7'>{data.duration} Days</label>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default TransferLog;
